import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Box, Button } from '@mui/material';
import { BlockOutlined } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { COMPANY_NAME, APP_VERSION } from '../constants';

const AccessDenied = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const email = searchParams.get('email') || '';

  const handleSignOut = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5', py: 4 }}>
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              mb: 2,
              backgroundColor: 'transparent',
              '& img': {
                display: 'block',
                maxHeight: 120,
                maxWidth: '100%',
                objectFit: 'contain',
                backgroundColor: 'transparent',
                border: 'none',
                boxShadow: 'none',
                verticalAlign: 'middle',
              },
            }}
          >
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt={COMPANY_NAME}
              onError={(e) => {
                const el = e.target;
                if (el.dataset.triedSvg) el.style.display = 'none';
                else { el.dataset.triedSvg = '1'; el.src = process.env.PUBLIC_URL + '/logo.svg'; }
              }}
              style={{ background: 'transparent' }}
            />
          </Box>

          <Paper elevation={3} sx={{ padding: 4, width: '100%' }}>
            <BlockOutlined sx={{ fontSize: 48, color: '#d32f2f', mb: 2, display: 'block', mx: 'auto' }} />
            <Typography component="h1" variant="h6" align="center" gutterBottom sx={{ fontWeight: 600 }}>
              Access Not Configured
            </Typography>
            <Typography variant="body1" align="center" sx={{ mb: 2, color: 'text.secondary' }}>
              Your account does not have access to the School Year Management System. Please contact your administrator to be assigned to the appropriate access group.
            </Typography>
            {email && (
              <Typography variant="body2" align="center" sx={{ mb: 2, color: 'text.secondary', fontFamily: 'monospace' }}>
                {decodeURIComponent(email)}
              </Typography>
            )}
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
              <Button variant="contained" onClick={handleSignOut}>
                Sign Out
              </Button>
            </Box>
          </Paper>

          <Typography
            component="footer"
            variant="caption"
            color="text.secondary"
            sx={{ mt: 3, textAlign: 'center', display: 'block' }}
          >
            © {new Date().getFullYear()} HASC · School Year Management System · v{APP_VERSION}
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default AccessDenied;
